/**
 * Navigation DTOs - API data transfer objects
 */

export interface OTObjectDTO {
  objectID: number;
  objectName: string;
  objectTypeID: number;
  objectType: string;
  parentID: number;
  objectStatus: string;
  colorCode: string;
  description: string;
  isAsset: boolean;
  isConnected: boolean;
  warning: boolean;
  critical: boolean;
  equipmentTypeID?: number;
  equipmentType: string;
  childCount: number;
  geoPosition: string;
  children?: OTObjectDTO[];
  picture: string;
  thumbnail: string;
  curLayer: string;
  nextLayer: string;
  layerName: string;
  layerID: number;
  buildingPlan: string;
  buildingPlanName: string;
  sensors?: SensorDTO[];
  delete?: boolean;
  structureFloorZone?: boolean;
  structureSectionCrossing?: boolean;
  structureAssociatedEquipment?: boolean;
  displayOrder?: number;
  customerName: string;
  sensorDigitIDs: string;
  edgeDeviceIDs: string;
  macs: string;
  gatewayIDs: string;
  defaultImageId?: string;
}

export interface SensorDTO {
  sensorID: number;
  sensorName: string;
  parentID: number;
  sensorTypeID?: number;
  connected: boolean;
  parentEquipmentType?: string;
  sensorX?: number;
  sensorY?: number;
  markerText?: string;
  installedBy?: string;
  geoPosition?: string;
  junctionBoxSlot?: string;
  picture?: string;
  thumbnail?: string;
  latitude?: number;
  longitude?: number;
  lastSync?: string;
  externalID?: string;
  sensorDigits?: string;
  edgeDigits?: string;
  sensorStatus?: string;
  sensorStatusColor?: string;
  telemetry?: unknown[];
  isGhostSensor?: boolean;
  equipmentSensorX?: number;
  equipmentSensorY?: number;
  equipmentMarkerText?: string;
}
